<template>
<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.6897 8.00016C1.6897 8.00016 3.6897 3.3335 8.35636 3.3335C13.023 3.3335 15.023 8.00016 15.023 8.00016C15.023 8.00016 13.023 12.6668 8.35636 12.6668C3.6897 12.6668 1.6897 8.00016 1.6897 8.00016Z" stroke="#7285AB" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.35645 10C9.46101 10 10.3564 9.10457 10.3564 8C10.3564 6.89543 9.46101 6 8.35645 6C7.25188 6 6.35645 6.89543 6.35645 8C6.35645 9.10457 7.25188 10 8.35645 10Z" stroke="#7285AB" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
